import React from 'react'
import { Box } from '@mui/material'
import Component from './component'
const Container = ({ data, action, maxWidth = 360 }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', gap: .5, alignItems: 'center', flexWrap: 'wrap', maxWidth, overflow: 'hidden' }}>
      {!!action && <Component event={{ key: 'action', value: action, type: 'translation' }} />}
      {_.map(data, (event) => <Component key={event?.key} event={event} />)}
    </Box>
  )
}

export default Container
